<mat-progress-spinner [color]="'primary'" [mode]="'indeterminate'"></mat-progress-spinner>
